import React, { memo } from 'react';
import classNames from 'classnames';
import cls from './ShowCompleted.module.css';
import { useShowCompleted } from '../../lib/hooks/useShowCompleted';
import { Switcher } from 'shared/ui';
import { useTranslation } from 'react-i18next';

interface ShowCompletedProps {
    classes?: string;
}

export const ShowCompleted = memo(({ classes }: ShowCompletedProps) => {
    const { t } = useTranslation();

    const { isShowCompleted, toggle } = useShowCompleted();

    return (
        <div className={classNames(cls.ShowCompleted, [classes])}>
            <Switcher
                isActive={isShowCompleted}
                onClick={toggle}
                title={t('ShowCompleted.return.Switcher.title')}
            />
        </div>
    );
});
